import {doNothing} from '@raison/toolbox';
import {RsnCheckbox, RsnDialog, RsnIconWidget} from '@raison/ui-kit';
import React, {useState} from 'react';
import {TransactionGroupName, TransactionsHistory} from '~/entities/transactions-history';
import {TransactionIcons} from '~/features/transitions-list';
import {FilterPopupLayout} from '../FilterPopupLayout';
import BottomButtons from './BottomButtons/BottomButtons';
import {isFilterUnchanged} from './shared';

const {exchange, incomings, outgoings, purchase} = TransactionIcons;

type TypeOptions = {
    label: string;
    groupName: TransactionGroupName;
    logo: string;
};

const options: TypeOptions[] = [
    {
        label: 'Incomings',
        groupName: 'incomings',
        logo: incomings,
    },
    {
        label: 'Outgoings',
        groupName: 'outgoings',
        logo: outgoings,
    },
    {
        label: 'Exchange',
        groupName: 'exchange',
        logo: exchange,
    },
    {
        label: 'Unit purchase',
        groupName: 'unit_purchase',
        logo: purchase,
    },
];

export const GroupFilterPopup = () => {
    const [{group: appliedFilters}, {apply: applyFilters}] = TransactionsHistory.useFilters();
    const [selected, setSelected] = useState(() => new Set(appliedFilters));
    const {onClose: close = doNothing} = RsnDialog.useControls();

    const nothingChanged = isFilterUnchanged(appliedFilters, selected);
    const nothingSelected = selected.size === 0;

    const onChange = (itemName: TransactionGroupName, checked: boolean) =>
        setSelected((prevState: typeof selected) => {
            if (checked) {
                return new Set(prevState).add(itemName);
            } else {
                return new Set(Array.from(prevState).filter(groupName => groupName !== itemName));
            }
        });

    const onApply = () => {
        close();
        applyFilters({group: Array.from(selected)});
    };

    const onClear = () => {
        setSelected(new Set());
    };

    return (
        <FilterPopupLayout
            title='Operation type'
            padding={'none'}
            footer={
                <BottomButtons
                    isApplyDisabled={nothingChanged}
                    isClearHidden={nothingSelected}
                    applyCallback={onApply}
                    clearCallback={onClear}
                />
            }
        >
            <div className='flex flex-col'>
                {options.map(({label, groupName, logo}) => (
                    <RsnIconWidget.Lg
                        key={label}
                        icon={{src: logo}}
                        as='label'
                        className={'p-4'}
                        addon={
                            <RsnCheckbox
                                onChange={e => onChange(groupName, e.target.checked)}
                                checked={selected.has(groupName)}
                            />
                        }
                    >
                        <RsnIconWidget.Text children={label} />
                    </RsnIconWidget.Lg>
                ))}
            </div>
        </FilterPopupLayout>
    );
};
